/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
const fontAwesomeCategories = [
	{
		name: "accessibility",
		title: __("Accessibility", "iconblock"),
	},
	{
		name: "alert",
		title: __("Alert", "iconblock"),
	},
	{
		name: "animals",
		title: __("Animals", "iconblock"),
	},
	{
		name: "arrows",
		title: __("Arrows", "iconblock"),
	},
	{
		name: "audio-video",
		title: __("Audio & Video", "iconblock"),
	},
	{
		name: "automotive",
		title: __("Automotive", "iconblock"),
	},
	{
		name: "autumn",
		title: __("Autumn", "iconblock"),
	},
	{
		name: "beverage",
		title: __("Beverage", "iconblock"),
	},
	{
		name: "buildings",
		title: __("Buildings", "iconblock"),
	},
	{
		name: "business",
		title: __("Business", "iconblock"),
	},
	{
		name: "camping",
		title: __("Camping", "iconblock"),
	},
	{
		name: "charity",
		title: __("Charity", "iconblock"),
	},
	{
		name: "chat",
		title: __("Chat", "iconblock"),
	},
	{
		name: "chess",
		title: __("Chess", "iconblock"),
	},
	{
		name: "childhood",
		title: __("Childhood", "iconblock"),
	},
	{
		name: "clothing",
		title: __("Clothing", "iconblock"),
	},
	{
		name: "code",
		title: __("Code", "iconblock"),
	},
	{
		name: "communication",
		title: __("Communication", "iconblock"),
	},
	{
		name: "computers",
		title: __("Computers", "iconblock"),
	},
	{
		name: "construction",
		title: __("Construction", "iconblock"),
	},
	{
		name: "currency",
		title: __("Currency", "iconblock"),
	},
	{
		name: "date-time",
		title: __("Date & Time", "iconblock"),
	},
	{
		name: "design",
		title: __("Design", "iconblock"),
	},
	{
		name: "editors",
		title: __("Editors", "iconblock"),
	},
	{
		name: "education",
		title: __("Education", "iconblock"),
	},
	{
		name: "emoji",
		title: __("Emoji", "iconblock"),
	},
	{
		name: "energy",
		title: __("Energy", "iconblock"),
	},
	{
		name: "files",
		title: __("Files", "iconblock"),
	},
	{
		name: "finance",
		title: __("Finance", "iconblock"),
	},
	{
		name: "fitness",
		title: __("Fitness", "iconblock"),
	},
	{
		name: "food",
		title: __("Food", "iconblock"),
	},
	{
		name: "fruit-vegetable",
		title: __("Fruits & Vegetables", "iconblock"),
	},
	{
		name: "games",
		title: __("Games", "iconblock"),
	},
	{
		name: "gaming-tabletop",
		title: __("Tabletop Gaming", "iconblock"),
	},
	{
		name: "gender",
		title: __("Genders", "iconblock"),
	},
	{
		name: "halloween",
		title: __("Halloween", "iconblock"),
	},
	{
		name: "hands",
		title: __("Hands", "iconblock"),
	},
	{
		name: "health",
		title: __("Health", "iconblock"),
	},
	{
		name: "holiday",
		title: __("Holiday", "iconblock"),
	},
	{
		name: "hotel",
		title: __("Hotel", "iconblock"),
	},
	{
		name: "household",
		title: __("Household", "iconblock"),
	},
	{
		name: "images",
		title: __("Images", "iconblock"),
	},
	{
		name: "interfaces",
		title: __("Interfaces", "iconblock"),
	},
	{
		name: "logistics",
		title: __("Logistics", "iconblock"),
	},
	{
		name: "maps",
		title: __("Maps", "iconblock"),
	},
	{
		name: "maritime",
		title: __("Maritime", "iconblock"),
	},
	{
		name: "marketing",
		title: __("Marketing", "iconblock"),
	},
	{
		name: "mathematics",
		title: __("Mathematics", "iconblock"),
	},
	{
		name: "medical",
		title: __("Medical", "iconblock"),
	},
	{
		name: "moving",
		title: __("Moving", "iconblock"),
	},
	{
		name: "music",
		title: __("Music", "iconblock"),
	},
	{
		name: "objects",
		title: __("Objects", "iconblock"),
	},
	{
		name: "payments-shopping",
		title: __("Payments & Shopping", "iconblock"),
	},
	{
		name: "pharmacy",
		title: __("Pharmacy", "iconblock"),
	},
	{
		name: "political",
		title: __("Political", "iconblock"),
	},
	{
		name: "religion",
		title: __("Religion", "iconblock"),
	},
	{
		name: "science",
		title: __("Science", "iconblock"),
	},
	{
		name: "science-fiction",
		title: __("Science Fiction", "iconblock"),
	},
	{
		name: "security",
		title: __("Security", "iconblock"),
	},
	{
		name: "shapes",
		title: __("Shapes", "iconblock"),
	},
	{
		name: "shopping",
		title: __("Shopping", "iconblock"),
	},
	{
		name: "social",
		title: __("Social", "iconblock"),
	},
	{
		name: "spinners",
		title: __("Spinners", "iconblock"),
	},
	{
		name: "sports",
		title: __("Sports", "iconblock"),
	},
	{
		name: "spring",
		title: __("Spring", "iconblock"),
	},
	{
		name: "status",
		title: __("Status", "iconblock"),
	},
	{
		name: "summer",
		title: __("Summer", "iconblock"),
	},
	{
		name: "toggle",
		title: __("Toggle", "iconblock"),
	},
	{
		name: "travel",
		title: __("Travel", "iconblock"),
	},
	{
		name: "users-people",
		title: __("Users & People", "iconblock"),
	},
	{
		name: "vehicles",
		title: __("Vehicles", "iconblock"),
	},
	{
		name: "weather",
		title: __("Weather", "iconblock"),
	},
	{
		name: "winter",
		title: __("Winter", "iconblock"),
	},
	{
		name: "writing",
		title: __("Writing", "iconblock"),
	},
];
export default fontAwesomeCategories;
